import { createApp } from 'vue'
import router from './router' // 引入路由配置文件
import './public.css'
import Toast from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import './assets/toast-custom.css'; // 👈我们自己加样式（下一步写）
import App from './App.vue'

const app = createApp(App)
app.use(Toast, {
    autoClose: 1500,
    hideProgressBar: true,
    closeButton: false,
    icon: false,
    position: 'top-center',
    theme: 'dark'
});
app.use(router) // 使用路由
app.mount('#app')
